var $9e0ecbff0edc4c96$exports = {};
$9e0ecbff0edc4c96$exports = {
    "invalidSelection": (args, formatter)=>`${formatter.plural(args.selectedCount, {
            one: `Wybrana data jest niedost\u{119}pna`,
            other: `Wybrane daty s\u{105} niedost\u{119}pne`
        })}.`
};


export {$9e0ecbff0edc4c96$exports as default};
//# sourceMappingURL=pl-PL.mjs.map
